import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 8.132a6.016 6.016 0 0 1-1.82 4.51 5.841 5.841 0 0 1-4.06 1.48 6.124 6.124 0 0 1-5.47-3.37 6.142 6.142 0 0 1 0-5.5 6.124 6.124 0 0 1 5.47-3.37 5.862 5.862 0 0 1 4.1 1.59l-1.73 1.68a3.418 3.418 0 0 0-2.37-.91 3.7 3.7 0 0 0-3.49 2.55A4.031 4.031 0 0 0 4.44 8a3.745 3.745 0 0 0 .2 1.21 3.759 3.759 0 0 0 5.61 1.93 3.012 3.012 0 0 0 1.25-1.99H8.12V6.882h5.75a5.162 5.162 0 0 1 .13 1.25Z';
const draw24px =
  'M21.3,12.24a9.3,9.3,0,0,1-2.83,7,9.05,9.05,0,0,1-6.28,2.29,9.49,9.49,0,0,1,0-19A9.13,9.13,0,0,1,18.54,5L15.86,7.62a5.29,5.29,0,0,0-3.67-1.41,5.73,5.73,0,0,0-5.41,3.94A6.12,6.12,0,0,0,6.48,12a5.82,5.82,0,0,0,.31,1.87,5.72,5.72,0,0,0,5.4,4,5.61,5.61,0,0,0,3.29-1,4.68,4.68,0,0,0,1.94-3.08H12.19V10.3H21.1A8.51,8.51,0,0,1,21.3,12.24Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoGoogleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoGoogle'),
) as IconWithRender;

LogoGoogleIcon.displayName = 'LogoGoogleIcon';
LogoGoogleIcon.propTypes = Icon.propTypes;
LogoGoogleIcon.renderIcon = (props) => <LogoGoogleIcon {...props} />;
export default LogoGoogleIcon;
